import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {GallerySearchParams} from '../../gallery-search-params';
import {Gallery} from '../../gallery';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-gallery-list',
  templateUrl: './gallery-list.component.html',
  styleUrls: []
})
export class GalleryListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new GallerySearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/gallery', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: Gallery) {
    this.router.navigateByUrl(`/gallery/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/gallery/create']);
  }
}
